import { render } from "./DiamondsView.vue?vue&type=template&id=29a1b606"
import script from "./DiamondsView.vue?vue&type=script&lang=js"
export * from "./DiamondsView.vue?vue&type=script&lang=js"

import "./DiamondsView.vue?vue&type=style&index=0&id=29a1b606&lang=css"

import exportComponent from "C:\\Development\\konnektor\\scores\\kon-platform-wallboards-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__